import { FC } from 'react';

import { Group, Skeleton, Stack, StackProps } from '@mantine/core';

const NotificationsSkeleton: FC<{ nbRows?: number } & StackProps> = ({ nbRows = 5, ...props }) => (
    <Stack gap="lg" {...props}>
        {Array.from({ length: nbRows }, (_, index) => (
            <Group key={index} gap="sm" wrap="nowrap" align="flex-start">
                <Skeleton circle height={32} />
                <Stack gap={8} flex={1} pt={4}>
                    <Skeleton height={10} width="85%" radius="xs" />
                    <Skeleton height={10} width="55%" radius="xs" />
                </Stack>
            </Group>
        ))}
    </Stack>
);

export { NotificationsSkeleton };
